import type { HTMLAttributes } from "react";
import { cx } from "../../lib/cx";
import styles from "./Divider.module.css";

export type DividerProps = HTMLAttributes<HTMLHRElement>;

export const Divider = ({ className, ...rest }: DividerProps) => (
  <hr className={cx(styles.divider, className)} {...rest} />
);
